<template>
  <div class="abody">
    <div class="ablockly">
      <el-button
        type="primary"
        class="btnPosition"
        @click="start()"
        v-if="type == '2'"
        >{{ loading ? "运行" : "加载中..." }}</el-button
      >
      <div id="blocklyDiv"></div>
      <xml id="toolbox" style="display: none">
        <category name="逻辑" colour="%{BKY_LOGIC_HUE}">
          <block type="controls_if"></block>
          <block type="logic_compare"></block>
          <block type="logic_operation"></block>
          <block type="logic_negate"></block>
          <block type="logic_boolean"></block>
        </category>
        <sep></sep>
        <category id="catIOTScreen" name="屏幕" colour="#5cb2d6">
          <block type="iot_lcd_screeninit"></block>
        </category>
        <sep></sep>
        <category id="cat" name="人脸识别" colour="#ee783a">
          <block type="iot_lcd_faceinit"></block>
        </category>
        <sep></sep>
        <category id="police" name="电子警察组件" colour="#1b5873">
          <block type="iot_lcd_policeinit"></block>
          <block type="iot_lcd_trunLeftinit"></block>
          <block type="iot_lcd_trunRightinit"></block>
        </category>
      </xml>
    </div>
    <iframe
      src="https://meta.cocorobo.cn"
      frameborder="0"
      ref="unityvue"
      allow="microphone;camera;midi;encrypted-media;"
    ></iframe>
  </div>
</template>

<script>
// 引入Blockly
import Blockly from "blockly";
// 引入想要转换的语言，语言有php python dart lua javascript
import * as JavaScript from "blockly/javascript";
import * as Blocks from "blockly/blocks";
// 引入语言包并使用
import * as hans from "blockly/msg/zh-hans";
Blockly.setLocale(hans);
//引入媒体文件：我是在github上下载的blockly源码，将源码中的media文件放入我项目中的public文件夹下

//忽略被vue错认为组件的blockly中的标签，不止以下这些，请发现一个忽略一个
import Vue from "vue";
Vue.config.ignoredElements.push("xml");
Vue.config.ignoredElements.push("block");
Vue.config.ignoredElements.push("field");
Vue.config.ignoredElements.push("category");
Vue.config.ignoredElements.push("sep");
Vue.config.ignoredElements.push("value");
Vue.config.ignoredElements.push("statement");
Vue.config.ignoredElements.push("mutation");

export default {
  data() {
    return {
      that: this,
      workspace: null,
      type: this.$route.query.type,
      loading: false,
      active: false,
    };
  },

  methods: {
    // 代码生成器
    myUpdateFunction(event) {
      var code = Blockly.JavaScript.workspaceToCode(this.workspace);
      return code;
    },
    // 获取blockly工作区中的code和xml结构
    getBlockData() {
      const code = Blockly.JavaScript.workspaceToCode(this.workspace);
      const xml = Blockly.Xml.workspaceToDom(this.workspace);
      const xmlText = Blockly.Xml.domToText(xml);
    },
    // 回显工作区中的xml结构
    setBlockData(xmlText) {
      this.clearBlockData();
      const xml = Blockly.Xml.textToDom(xmlText);
      Blockly.Xml.domToWorkspace(xml, this.workspace);
    },
    // 清空工作区
    clearBlockData() {
      this.workspace.clear();
    },
    //运行
    start() {
      var a = this.myUpdateFunction();
      console.log(a);
      var array = a.split(";");
      if (this.loading) {
        if (this.active) {
          // this.$refs.unityvue.contentWindow.postMessage({ do: "1" }, "*");
          // this.$refs.unityvue.contentWindow.postMessage({ do: "trunLeft" }, "*");
          for (let i = 0; i < array.length; i++) {
            setTimeout(() => {
              if (array[i].indexOf("screen") != -1) {
                this.$refs.unityvue.contentWindow.postMessage({ do: "1" }, "*");
              }else if (array[i].indexOf("trunLeft") != -1) {
                this.$refs.unityvue.contentWindow.postMessage({ do: "trunLeft" }, "*");
              }else if (array[i].indexOf("trunRight") != -1) {
                this.$refs.unityvue.contentWindow.postMessage({ do: "trunRight" }, "*");
              }
            }, 200 * i);
          }
        } else {
          this.$message.error("请拼接完才能执行");
        }
      }
    },
  },

  mounted() {
    this.workspace = Blockly.inject("blocklyDiv", {
      //工具栏
      toolbox: document.getElementById("toolbox"),
      //网格效果
      grid: { spacing: 20, length: 3, colour: "#ccc", snap: true },
      //媒体资源
      media: "../assets/img/",
      //垃圾桶
      trashcan: true,
    });
    //工作区监听代码生成器
    this.workspace.addChangeListener(this.myUpdateFunction);

    Blockly.Blocks["iot_lcd_screeninit"] = {
      init: function () {
        this.appendDummyInput().appendField(
          new Blockly.FieldImage(
            require("../assets/img/screen_init_header.png"),
            45,
            45
          )
        );
        this.appendDummyInput().appendField("LCD屏幕打开");
        this.setInputsInline(false);
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setColour("#5cb2d6");
        this.setTooltip("");
        this.setHelpUrl("");
      },
    };

    Blockly.JavaScript.iot_lcd_screeninit = function (block) {
      var _code = "screen=1;";
      return _code;
    };

    Blockly.Blocks["iot_lcd_faceinit"] = {
      init: function () {
        this.appendDummyInput().appendField(
          new Blockly.FieldImage(
            require("../assets/img/face_recognition_header.png"),
            45,
            45
          )
        );
        this.appendDummyInput().appendField("人脸辨识");
        this.setInputsInline(false);
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setColour("#ee783a");
        this.setTooltip("");
        this.setHelpUrl("");
      },
    };

    Blockly.JavaScript.iot_lcd_faceinit = function (block) {
      var _code = "face=1;";
      return _code;
    };

    Blockly.Blocks["iot_lcd_policeinit"] = {
      init: function () {
        this.appendDummyInput().appendField(
          new Blockly.FieldImage(
            require("../assets/img/screen_init_header.png"),
            45,
            45
          )
        );
        this.appendDummyInput().appendField("电子警察组件");
        this.setInputsInline(false);
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setColour("#1b5873");
        this.setTooltip("");
        this.setHelpUrl("");
      },
    };

    Blockly.JavaScript.iot_lcd_policeinit = function (block) {
      var _code = "police=1;";
      return _code;
    };

    Blockly.Blocks["iot_lcd_trunLeftinit"] = {
      init: function () {
        this.appendDummyInput().appendField("向左移动");
        this.setInputsInline(false);
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setColour("#1b5873");
        this.setTooltip("");
        this.setHelpUrl("");
      },
    };

    Blockly.JavaScript.iot_lcd_trunLeftinit = function (block) {
      var _code = "trunLeft=1;";
      return _code;
    };

    Blockly.Blocks["iot_lcd_trunRightinit"] = {
      init: function () {
        this.appendDummyInput().appendField("向右移动");
        this.setInputsInline(false);
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setColour("#1b5873");
        this.setTooltip("");
        this.setHelpUrl("");
      },
    };

    Blockly.JavaScript.iot_lcd_trunRightinit = function (block) {
      var _code = "trunRight=1;";
      return _code;
    };
    var that = this;
    window.addEventListener("message", function (e) {
      // 监听 message 事件
      if (e.data.success) {
        that.loading = true;
        that.$refs.unityvue.contentWindow.postMessage({ type: that.type }, "*");
      }

      if (e.data.active) {
        that.active = true;
      } else if (e.data.active != undefined) {
        that.active = false;
      }

      if (e.data.noCamera) {
        that.$message.error(e.data.noCamera);
      }
    });
  },
};
</script>

<style>
.abody {
  width: 100%;
  height: 100%;
  display: flex;
}

#blocklyDiv {
  width: 100%;
  height: 100%;
}

.ablockly {
  width: 50%;
  height: 100%;
}

.abody iframe {
  width: 50%;
  height: 100%;
}

.blocklySvg {
  height: 905px !important;
}

.ablockly {
  position: relative;
}

.btnPosition {
  position: absolute;
  right: 130px;
  bottom: 35px;
  z-index: 999999;
}
</style>


// WEBPACK FOOTER //
// src/components/unity.vue